var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[(!_vm.invoice)?_c('base-table-spinner'):_c('InvoicePreview',{attrs:{"invoice":_vm.invoice}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }